import { PAGE_TYPE_SEARCH_RESULTS } from 'shared/consts'

export const ODS_MODAL_PAGE_BTN_ID_REMAINDER_ZAVA_CLICK = 'rx-zavaClick'
export const ODS_MODAL_SEARCH_PAGE_BTN_ID = `${PAGE_TYPE_SEARCH_RESULTS}-${ODS_MODAL_PAGE_BTN_ID_REMAINDER_ZAVA_CLICK}`
